<template>

<div class="pricing-plans row no-gutters">
    <div class="pricing-plan col-sm-12">
        <div class="plan-head">
            <ProductImageCarousel :product="product" :session="session" :type="'final_images'"/>
        </div>

        <div class="plan-description">

            <h6>Parent</h6>
            <p class="text-capitalize">{{currentProduct.Item_Parent}}</p>
            <h6>Identifier</h6>
            <p class="text-capitalize">{{currentProduct.Item}}</p>
            <h6>Image Name</h6>
            <p class="text-capitalize">{{currentProduct.Item_Parent}}</p>
        </div>
    </div>
</div>
</template>

<script>
import ProductImageCarousel from '@/components/common/SessionView/ProductImageCarousel'

export default {
  props: ['session', 'product'],
  components: { ProductImageCarousel },
  computed: {
    currentProduct () {
      return this.product
    }
  }
}
</script>

<style scoped>
.pricing-plan .plan-head {
    background-color: #f2f4f8;
    padding-top: 10px;
}
.pricing-plan, .pricing-plan .plan-body {
    background-color: #f2f4f8;
}
.plan-description {
    background-color: #f2f4f8;
    padding: 10px;
}

</style>
